import { render, staticRenderFns } from "./HospitalService.vue?vue&type=template&id=27a467ad&scoped=true"
import script from "./HospitalService.vue?vue&type=script&lang=js"
export * from "./HospitalService.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27a467ad",
  null
  
)

export default component.exports